import React, { useLayoutEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function LegalNoticePage() {
  const navigate = useNavigate();
  const pageTopRef = useRef(null);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
    }
  }, []);

  const handleBack = () => {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }

    navigate(-1);
  };

  return (
    <div ref={pageTopRef} className="legal-page">
      <style>{`
        .legal-page {
          min-height: 100vh;
          background: #f7faf8;
          color: #111827;
          font-family: Inter, "Avenir Next", Arial, sans-serif;
          line-height: 1.65;
        }

        .legal-shell {
          max-width: 960px;
          margin: 0 auto;
          padding: 34px 24px 72px;
        }

        .legal-back {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 26px;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .legal-back:hover {
          text-decoration: underline;
        }

        .legal-back-button {
          border: none;
          background: transparent;
          padding: 0;
          cursor: pointer;
          font-family: inherit;
        }

        .legal-hero {
          padding: 46px 44px;
          margin-bottom: 26px;
          border-radius: 28px;
          color: #ffffff;
          background: linear-gradient(135deg, #0c6943 0%, #148a58 100%);
          box-shadow: 0 18px 48px rgba(20, 138, 88, 0.16);
        }

        .legal-hero-label {
          display: inline-flex;
          padding: 6px 13px;
          margin-bottom: 18px;
          border: 1px solid rgba(255, 255, 255, 0.25);
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.13);
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        .legal-hero h1 {
          margin: 0 0 13px;
          font-size: clamp(34px, 5vw, 47px);
          font-weight: 760;
          line-height: 1.1;
          letter-spacing: -0.045em;
        }

        .legal-hero-description {
          max-width: 720px;
          margin: 0;
          color: rgba(255, 255, 255, 0.9);
          font-size: 16px;
        }

        .legal-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 11px;
          margin-top: 30px;
        }

        .legal-meta-item {
          padding: 9px 13px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.11);
          color: rgba(255, 255, 255, 0.94);
          font-size: 13px;
        }

        .legal-card {
          padding: 30px 32px;
          margin-bottom: 17px;
          border: 1px solid #e3ebe6;
          border-radius: 22px;
          background: #ffffff;
          box-shadow: 0 5px 22px rgba(17, 24, 39, 0.035);
        }
          .legal-card .legal-normal-text {
  margin: 0 0 13px;
  color: #374151;
  font-size: 15px;
  line-height: 1.65;
  font-weight: 400;
}

.legal-card p:last-child {
  margin-bottom: 0;
}

        .legal-card h2 {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 0 0 16px;
          color: #111827;
          font-size: 21px;
          font-weight: 720;
          letter-spacing: -0.02em;
        }

        .legal-number {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 11px;
          background: #e9f6ef;
          color: #148a58;
          font-size: 14px;
          font-weight: 750;
        }

        .legal-card p {
          margin: 0 0 13px;
          color: #374151;
          font-size: 15px;
        }

        .legal-card p:last-child {
          margin-bottom: 0;
        }

        .legal-details {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
          margin-top: 18px;
        }

        .legal-detail-box {
          padding: 15px 16px;
          border: 1px solid #e3ebe6;
          border-radius: 14px;
          background: #f8fbf9;
        }

        .legal-detail-wide {
          grid-column: 1 / -1;
        }

        .legal-detail-label {
          display: block;
          margin-bottom: 4px;
          color: #64748b;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }

        .legal-detail-value {
          color: #24372d;
          font-size: 14px;
          font-weight: 550;
        }

        .legal-link {
          color: #148a58;
          font-weight: 600;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        .legal-list {
          margin: 8px 0 0;
          padding-left: 21px;
          color: #374151;
          font-size: 15px;
        }

        .legal-list li {
          margin-bottom: 9px;
          padding-left: 3px;
        }

        .legal-list li:last-child {
          margin-bottom: 0;
        }

        .legal-highlight {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #148a58;
          border-radius: 13px;
          background: #f1faf5;
          color: #244536;
          font-size: 14px;
        }

        .legal-notice {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #d59b25;
          border-radius: 13px;
          background: #fffaf0;
          color: #594019;
          font-size: 14px;
        }

        .legal-documents {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
          margin-top: 18px;
        }

        .legal-document-link {
          display: block;
          padding: 14px 15px;
          border: 1px solid #e3ebe6;
          border-radius: 13px;
          background: #f8fbf9;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .legal-document-link:hover {
          border-color: #b8dcc8;
          background: #f1faf5;
        }

        .legal-contact {
          padding: 30px 32px;
          margin-top: 20px;
          border-radius: 22px;
          background: #10271e;
          color: #ffffff;
        }

        .legal-contact h2 {
          margin: 0 0 10px;
          font-size: 21px;
          letter-spacing: -0.02em;
        }

        .legal-contact p {
          margin: 0 0 14px;
          color: rgba(255, 255, 255, 0.82);
          font-size: 15px;
        }

        .legal-contact a {
          color: #ffffff;
          font-weight: 650;
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        .legal-footer {
          padding-top: 30px;
          color: #64748b;
          font-size: 13px;
          text-align: center;
        }

        @media (max-width: 640px) {
          .legal-shell {
            padding: 20px 15px 48px;
          }

          .legal-hero {
            padding: 32px 23px;
            border-radius: 21px;
          }

          .legal-card,
          .legal-contact {
            padding: 23px 20px;
            border-radius: 18px;
          }

          .legal-card h2 {
            align-items: flex-start;
            font-size: 19px;
          }

          .legal-details,
          .legal-documents {
            grid-template-columns: 1fr;
          }

          .legal-detail-wide {
            grid-column: auto;
          }
            
        }
      `}</style>

      <main className="legal-shell">
        <button
          type="button"
          className="legal-back legal-back-button"
          onClick={handleBack}
        >
          ← Back to EcoTrack
        </button>

        <header className="legal-hero">
          <div className="legal-hero-label">Legal Information</div>

          <h1>Legal Notice</h1>

          <p className="legal-hero-description">
            This Legal Notice identifies the operator of EcoTrack and explains
            the nature and intended use of the digital ESG self-assessment and
            support service.
          </p>

          <div className="legal-meta">
            <div className="legal-meta-item">Last updated: 31 May 2026</div>
            <div className="legal-meta-item">Viridis by Serap Cevirgen</div>
            <div className="legal-meta-item">VAT No. 04191120130</div>
          </div>
        </header>

        <section className="legal-card">
          <h2>
            <span className="legal-number">1</span>
            Operator information
          </h2>

          <p>
            EcoTrack is a digital service operated by{" "}
            <strong>Viridis by Serap Cevirgen</strong>.
          </p>

          <div className="legal-details">
            <div className="legal-detail-box">
              <span className="legal-detail-label">Operator</span>
              <span className="legal-detail-value">
                Viridis by Serap Cevirgen
              </span>
            </div>

            <div className="legal-detail-box">
              <span className="legal-detail-label">VAT number</span>
              <span className="legal-detail-value">04191120130</span>
            </div>

            <div className="legal-detail-box legal-detail-wide">
              <span className="legal-detail-label">Business address</span>
              <span className="legal-detail-value">
                Via Luigi Dottesio n. 24, 22100 Como (CO), Italy
              </span>
            </div>

            <div className="legal-detail-box">
              <span className="legal-detail-label">Email</span>
              <span className="legal-detail-value">
                <a
                  className="legal-link"
                  href="mailto:serap.cevirgen@viridisconsultancy.com"
                >
                  serap.cevirgen@viridisconsultancy.com
                </a>
              </span>
            </div>

            <div className="legal-detail-box">
              <span className="legal-detail-label">Website</span>
              <span className="legal-detail-value">
                <a
                  className="legal-link"
                  href="https://www.viridisconsultancy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.viridisconsultancy.com
                </a>
              </span>
            </div>
          </div>
        </section>

        <section className="legal-card">
          <h2>
            <span className="legal-number">2</span>
            Nature of EcoTrack
          </h2>

          <p>
            <strong>2.1</strong> EcoTrack is a digital ESG self-assessment and
            support tool designed for business and professional users.
          </p>

          <p>
            <strong>2.2</strong> Depending on the available service
            configuration and subscription status, EcoTrack may allow users
            to:
          </p>

          <ul className="legal-list">
            <li>create and manage an account;</li>
            <li>complete onboarding and organisation-profile information;</li>
            <li>answer ESG questionnaires;</li>
            <li>view indicative scores, summaries, graphs and benchmarks;</li>
            <li>receive automated suggestions for improvement;</li>
            <li>download PDF outputs or related assessment materials.</li>
          </ul>

          <p style={{ marginTop: 16 }}>
            <strong>2.3</strong> EcoTrack uses information provided by users,
            together with rules-based automated processing, to generate
            indicative ESG-related outputs for internal decision-support
            purposes.
          </p>
        </section>

        <section className="legal-card">
          <h2>
            <span className="legal-number">3</span>
            Production availability and payment flow
          </h2>

          <p>
            <strong>3.1</strong> The live production version of EcoTrack is
            intended to be made available through the Viridis website and
            related application pages hosted within or connected to that
            website environment.
          </p>

          <p>
            <strong>3.2</strong> Where access to EcoTrack requires a paid
            subscription, users may be redirected to a secure checkout page
            hosted and operated by <strong>Stripe</strong> for payment
            processing and subscription-related payment functionality.
          </p>

          <p>
            <strong>3.3</strong> Information concerning personal-data
            processing, technical providers, hosted checkout and related
            technologies is provided in the{" "}
            <Link className="legal-link" to="/privacy-policy">
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link className="legal-link" to="/cookie-policy">
              Cookie Policy
            </Link>
            .
          </p>
        </section>

        <section className="legal-card">
          <h2>
            <span className="legal-number">4</span>
            No professional advice, certification or compliance guarantee
          </h2>

          <p>
            <strong>4.1</strong> All methodology, content, questionnaires,
            scores, summaries, graphs, benchmarking indicators, suggestions
            and downloadable outputs made available through EcoTrack are
            provided for general informational and internal business-support
            purposes only.
          </p>

          <p>
            <strong>4.2</strong> EcoTrack does not provide legal advice,
            regulatory advice, tax advice, accounting advice, investment
            advice, audit services, assurance services, certification services
            or any other professional advisory service.
          </p>

          <p>
            <strong>4.3</strong> EcoTrack does not guarantee compliance with
            CSRD, ESRS, EU Taxonomy requirements, ISO standards, EcoVadis
            requirements or any other legal, voluntary or commercial
            framework.
          </p>

<div className="legal-normal-text">
  EcoTrack results are indicative only. Users remain responsible for
  obtaining appropriate professional advice and for decisions taken
  in relation to sustainability strategy, disclosure, reporting,
  compliance or certification.
</div>
        </section>

        <section className="legal-card">
          <h2>
            <span className="legal-number">5</span>
            Business and professional use only
          </h2>

          <p>
            <strong>5.1</strong> EcoTrack is intended exclusively for business
            and professional users acting in connection with a trade, business
            or professional activity.
          </p>

          <p>
            <strong>5.2</strong> EcoTrack is not offered to private consumers
            acting outside their trade, business or professional activity.
          </p>

          <p>
            <strong>5.3</strong> During checkout, users are required to confirm
            that they are purchasing and using EcoTrack for professional or
            business purposes and, where applicable, that they are authorised
            to act on behalf of the relevant organisation or professional
            activity.
          </p>
        </section>

        <section className="legal-card">
          <h2>
            <span className="legal-number">6</span>
            Intellectual property and permitted use
          </h2>

          <p>
            <strong>6.1</strong> All intellectual property rights relating to
            EcoTrack, including its interface, methodology, written content,
            software logic, branding and service structure, remain the
            property of Viridis by Serap Cevirgen or its licensors, except
            where otherwise expressly stated.
          </p>

          <p>
            <strong>6.2</strong> Any permitted access to EcoTrack is governed
            by the{" "}
            <Link className="legal-link" to="/terms-and-conditions">
              Terms and Conditions
            </Link>
            .
          </p>
        </section>

        <section className="legal-card">
          <h2>
            <span className="legal-number">7</span>
            Related policies and contractual documents
          </h2>

          <p>
            Access to and use of EcoTrack are subject to the applicable legal
            and contractual documents made available through the service.
          </p>

          <div className="legal-documents">
            <Link className="legal-document-link" to="/terms-and-conditions">
              Terms and Conditions
            </Link>

            <Link className="legal-document-link" to="/privacy-policy">
              Privacy Policy
            </Link>

            <Link className="legal-document-link" to="/cookie-policy">
              Cookie Policy
            </Link>

            <Link className="legal-document-link" to="/refund-policy">
              Refund and Cancellation Policy
            </Link>

          
          </div>

          
        </section>

        <section className="legal-card">
          <h2>
            <span className="legal-number">8</span>
            Changes to this Legal Notice
          </h2>

          <p>
            This Legal Notice may be updated from time to time to reflect
            changes in the EcoTrack service, operator information, technical
            publication arrangements or applicable legal requirements.
          </p>

          <p>
            The date displayed at the top of this page identifies the most
            recent update.
          </p>
        </section>

        <section className="legal-contact">
          <h2>Contact</h2>

          <p>
            Support, billing or legal requests concerning EcoTrack may be sent
            to:
          </p>

          <a href="mailto:serap.cevirgen@viridisconsultancy.com">
            serap.cevirgen@viridisconsultancy.com
          </a>
        </section>

        <footer className="legal-footer">
          © 2026 Viridis by Serap Cevirgen · EcoTrack
        </footer>
      </main>
    </div>
  );
}